import { Fragment } from "react";
import { string, array, bool, func, number, oneOfType } from "prop-types";

const propTypes = {
  title: string.isRequired,
  breadcrumb: array,
  position: oneOfType([string, number]).isRequired,
  movable: bool,
  onRemoveReportItem: func,
};

const ReportItem = (props) => {
  const { title, breadcrumb, position, movable, onRemoveReportItem } = props;

  return (
    <div className="report-item">
      {movable && (
        <div className="report-item__icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-menu"
          >
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </div>
      )}
      <div className="report-item__position">{position}.</div>
      <div className="report-item__contents">
        <div className="report-item__title">{title}</div>
        {breadcrumb && (
          <div className="report-item__breadcrumb">
            {breadcrumb.map((crumb, index, arr) => (
              <Fragment key={index}>
                <span>{crumb}</span>
                {arr.length - 1 !== index && <span> {">"} </span>}
              </Fragment>
            ))}
          </div>
        )}
      </div>
      {position !== "I" && position !== "II" && (
        <button
          onClick={onRemoveReportItem}
          className="report-item__remove-item"
          type="button"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-x"
          >
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
  );
};

ReportItem.propTypes = propTypes;
export default ReportItem;
